import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  token: '',
  expiration: 0,
  type: '',
  empre: 0,
  roles: [],
}

export const AuthenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    updateCredentials: (state, { payload }) => {
      return { ...payload }
    },
    clearCredentials: (state, { payload }) => {
      return initialState
    },
  },
})

export const { updateCredentials, clearCredentials } = AuthenticationSlice.actions
export default AuthenticationSlice.reducer
